export default "__VITE_ASSET__Dx36KYyt__"